const tailwindPositions: {[key: string]: string} = {
  bottom: 'top-0',
  right: 'left-0',
  left: 'right-0',
  top: 'bottom-0',
}

export const getTailwindPositions = (position = '') =>
  position
    .split(' ')
    .map(item => tailwindPositions[item] || 'top-0')
    .join(' ')

// export const get = (
//   object = {},
//   keys = "",
//   defaultVal = "",
//   returnArray = false
// ): Array<string> => {
//   keys = Array.isArray(keys) ? keys : keys.split(".");
//   object = object[keys[0]];
//   if (object && keys.length > 1) {
//     return get(object, keys.slice(1), defaultVal, returnArray);
//   }
//   return object === undefined
//     ? defaultVal
//     : returnArray
//     ? Array.isArray(object)
//       ? object
//       : [object]
//     : object;
// };
